<template>
  <learn-layout>
    <template v-slot:content>
      <v-col :cols="12">

        <div class="text-h6 pt-3">Upload Videos to Torvue for Processing</div>
        <p>
          This article will show you how to use the Torvue Uploader software to take video files from your camera and publish them online for processing and sharing.
        </p>

        <p>You should already have the Uploader software installed on your computer. If not, make sure you go back and watch our how-to video first <router-link to="/uploader">(Hint: click here 👉)</router-link></p>


        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="text-h6">
                Macbook Guide
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>

              <div class="embed-youtube">
                <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/qt6KwRLzhuM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>

              <div class="text-h6 pt-3">Items needed</div>
              <ul>
                <li>Camera</li>
                <li>USB Cable (the one that came with the camera)</li>
                <li>Your Computer (Macbook or Windows)</li>
                <li>(for newer MacBook models) USB-C Adapter</li>
              </ul>

              <div class="text-h6 pt-3">Steps</div>
              <ol>
                <li>
                  Using your launchpad or Search Bar feature (Command + Space), locate and launch the Torvue Uploader.
                </li>
                <li>
                  Plug your camera into the computer via the USB cable, then turn your camera on.
                  <v-alert dense type="warning">Don’t forget to turn your camera on! Push and hold the power button until the blue light appears.</v-alert>
                </li>
                <li>The program will take a short moment to find the video files on your camera, then you will see them start to populate the screen.You may receive a request to “access files on a removable volume.” Click “Allow”. </li>
                <li>In this view, you can preview your video files. However, these are the raw video files and they do not contain advanced processing like image stabilization, audio enhancement, and color correction. Torvue processes and enhances your videos after you have uploaded the files.</li>
                <li>To upload your files to Torvue, click the “Upload” button and enter a title for your video. We recommend the street address of the listing you toured, or the name of the neighborhood you captured. When you begin the upload process, note how the video status changes to “Importing.” </li>
                <li>You may choose to have the files on your camera deleted once they are uploaded to to Torvue. This will make sure you always have space on your camera to record another video Simply check the box indicating you want this to happen.</li>
                <li>
                  Click “Submit” to initiate the upload process.
                </li>
              </ol>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="text-h6">
                Windows Guide
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>

              <div class="embed-youtube">
                <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/06AdLGzDmPM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>

              <div class="text-h6 pt-3">Items needed</div>
              <ul>
                <li>Camera</li>
                <li>USB Cable (the one that came with the camera)</li>
                <li>Your Computer (Macbook or Windows)</li>
              </ul>

              <div class="text-h6 pt-3">Steps</div>
              <ol>
                <li>
                  Open the Torvue uploader by double-clicking its icon on your desktop.
                </li>
                <li>
                  Plug your camera into the computer via the USB cable, then turn your camera on.
                  <v-alert dense type="warning">Don’t forget to turn your camera on! Push and hold the power button until the blue light appears.</v-alert>
                </li>
                <li>The program will take a short moment to find the video files on your camera, then you will see them start to populate the screen.</li>
                <li>In this view, you can preview your video files. However, these are the raw video files and they do not contain advanced processing like image stabilization, audio enhancement, and color correction. Torvue processes and enhances your videos after you have uploaded the files.</li>
                <li>To upload your files to Torvue, click the “Upload” button and enter a title for your video. We recommend the street address of the listing you toured, or the name of the neighborhood you captured. When you begin the upload process, note how the video status changes to “Importing.” </li>
                <li>You may choose to have the files on your camera deleted once they are uploaded to to Torvue. This will make sure you always have space on your camera to record another video Simply check the box indicating you want this to happen.</li>
                <li>
                  Click “Submit” to initiate the upload process.
                </li>
              </ol>

            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="text-h6 pt-6">
          Upload Times
        </div>
        <p>
          The video files you’re uploading to Torvue are huge, so they may take 30 minutes to 1 hour to upload, depending on your internet connection. We recommend letting your computer do its thing while the upload finishes.
        </p>
        <p>Torvue will notify you and send you a link to your video once it has been uploaded and processed.</p>

        <v-alert type="info">
          Torvue has in-built fail safe technology that tracks and saves the progress of each upload. If your internet goes out, or you accidentally shutdown your computer, Torvue will remember where it stopped and pick up right where it left off once the connection is restored.
        </v-alert>

      </v-col>
    </template>
    <template v-slot:footer>
      <div>
        <div class="caption font-italic">Previous step:</div>
        <v-btn class="float-end" color="secondary" outlined to="/learn/uploader" :small="$vuetify.breakpoint.smAndDown">
          <v-icon class="pr-2">mdi-arrow-left</v-icon>
          Install Uploader
        </v-btn>
      </div>
      <v-spacer />
<!--      <div>-->
<!--        <div class="caption font-italic">Next step:</div>-->
<!--        <v-btn class="float-end" color="primary" to="/learn/upload" :small="$vuetify.breakpoint.smAndDown">-->
<!--          Upload Tour-->
<!--          <v-icon class="pl-2">mdi-arrow-right</v-icon>-->
<!--        </v-btn>-->
<!--      </div>-->
    </template>
  </learn-layout>
</template>

<script>
import LearnLayout from "@/components/LearnLayout.vue";

export default {
  name: "Upload",
  components: {LearnLayout}
}
</script>

<style scoped>

</style>